function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 11.2L1.8 7 .4 8.4 6 14 18 2 16.6.6 6 11.2" fillRule="evenodd" /></svg>;
});